module.exports = __webpack_public_path__ + "img/1.1a1e0320.png";